<template>
  <div>
    <div class="footer-mobile" :class="{ 'menu-open': menuOpen }">
      <ul class="shortcuts" :class="getOS() === 'iOS' ? 'ios' : ''">
        <div>
          <li
            v-for="(link, i) in links"
            :key="i"
            :class="{ 'real-active': isRoute(link) }"
            @click="updateMenu"
            v-touch:swipe="onSwipeUp"
          >
            <router-link :to="{ name: link.name }">
              <i :class="`${isRoute(link) ? 'fas' : 'fal'} ${link.icon}`"></i>
              <span
                v-if="
                  typeof link.getCounter == 'function' && link.getCounter() > 0
                "
                class="notification"
              >
                {{ link.getCounter() }}
              </span>
            </router-link>
          </li>
          <li
            @click="menuOpen = !menuOpen"
            class="open-menu"
            :class="{
              'real-active': menuOpen,
              open: isOpenMenu && !isPausedMenu,
              close: !isOpenMenu,
              pause: isPausedMenu,
            }"
            v-touch:swipe="onSwipeUp"
          >
            <div class="plus">
              <i class="far fa-plus" :class="{ rotate: !!menuOpen }"></i>
            </div>
          </li>
        </div>
      </ul>

      <div class="menu-mobile" v-touch:swipe="onSwipeDown">
        <p class="greetings">
          {{ StringLanguage.hello }},
          <span class="name">{{ userName.split(' ')[0] }}</span>
        </p>

        <div
          class="status-store get-update"
          @click="toggleUpdate"
          v-if="hasUpdate || updateLater"
        >
          <p>Nova atualização</p>
        </div>

        <div
          v-if="
            storeConfiguration.published ||
            storeConfiguration.published === undefined
          "
          class="d-flex align-stretch mb_25"
        >
          <router-link :to="'/horario'" class="no-decoration w-100">
            <div
              class="status-store"
              :class="{
                uncollapse: statusOpen,
                open: isOpenMenu && !isPausedMenu,
                close: !isOpenMenu,
                pause: isPausedMenu,
              }"
              @click="updateMenu"
            >
              <!-- <div class="status-target" @click="statusOpen = !statusOpen"> -->
              <div class="status-target">
                <div
                  class="status"
                  :class="{
                    close: !isOpenMenu && !isPausedMenu,
                    pause: isPausedMenu,
                    open: !!isOpenMenu && !isPausedMenu,
                    loading: (isOpenMenu === null || isPausedMenu) && !timeleft,
                  }"
                  @click="changeTo('horario')"
                >
                  <div class="circle"></div>
                  <i class="fas fa-circle"></i>
                </div>
                <p>
                  {{ StringLanguage.store }}
                  <!-- <span v-if="isPausedMenu">
                    {{ StringLanguage.paused }} ({{ timeleft }})
                  </span> -->
                  <span v-if="isOpenMenu">{{ StringLanguage.opened }}</span>
                  <span v-else-if="!isOpenMenu">{{
                    StringLanguage.closed
                  }}</span>
                </p>
                <!-- <div>
                  <span v-if="statusOpen"><i class="fal fa-chevron-up"></i></span>
                  <span v-if="!statusOpen"><i class="fal fa-chevron-down"></i></span>
              </div> -->
              </div>

              <div
                v-if="!!statusOpen"
                @click="statusOpen = false"
                class="w-100"
              >
                <p class="status-option">
                  {{ StringLanguage.goToMyEcommerce }}
                </p>
                <p class="status-option" @click="changeTo('horario')">
                  {{ StringLanguage.goToWorkingTimes }}
                </p>
                <p
                  v-if="isPausedMenu"
                  class="status-option"
                  @click="pauseStore(null, null)"
                >
                  {{ StringLanguage.cancelPause }}
                </p>
                <p
                  v-if="!isPausedMenu && isOpenMenu"
                  class="status-option"
                  @click="pauseStore(15, 'minute')"
                >
                  {{ StringLanguage.pauseFor15Minutes }}
                </p>
                <p
                  v-if="!isPausedMenu && isOpenMenu"
                  class="status-option"
                  @click="pauseStore(1, 'hour')"
                >
                  {{ StringLanguage.pauseFor1Hour }}
                </p>
                <p
                  v-if="!isPausedMenu && isOpenMenu"
                  class="status-option"
                  @click="pauseStore(6, 'hour')"
                >
                  {{ StringLanguage.pauseFor6Hours }}
                </p>
              </div>
            </div>
          </router-link>
          <div class="store-details" @click="openDrawer()">
            <i class="fal fa-store" />
          </div>
        </div>
        <div
          v-if="
            isOpenMenu !== null &&
            !storeConfiguration.published &&
            storeConfiguration.published !== undefined
          "
          class="status-store open mb_25"
          @click="publishStore"
        >
          <p class="publish-text">Publicar loja</p>
        </div>

        <ul class="menu-grid">
          <li v-for="(link, i) in gridLinks" :key="i" @click="updateMenu">
            <router-link :to="{ name: link.name }">
              <div class="icon">
                <i :class="link.icon"></i>
              </div>
              <p>{{ link.title }}</p>
              <i class="fal fa-chevron-right" />
            </router-link>
          </li>
          <li>
            <a @click.prevent="logout()">
              <div class="icon">
                <i class="fal fa-power-off"></i>
              </div>
              <p>{{ StringLanguage.logout }}</p>
            </a>
          </li>
        </ul>
      </div>

      <DrawerStoreDetails ref="drawerStoreDetails" />
    </div>
  </div>
</template>

<script>
/* eslint-disable prefer-destructuring */
import { mapState } from 'vuex';
import dayjs from 'dayjs';
import SocketIO from 'easyjs/lib/Socket/SocketIO';
import Timezone from 'easyjs/lib/Tools/Timezone';
import Store from 'easyjs/lib/Schema/Store';
import store from '@/store';
import { setXUserKey } from '@/plugins/account';
import router from '@/router';
import Utils from '@/utils';
import DrawerStoreDetails from '@/containers/DrawerStoreDetails';
import StoreAPI from '@/api/store';

import getOS from '@/mixins/getOS.js';

export default {
  mixins: [getOS],
  timers: {
    timeLeft: { time: 1000, autostart: true, repeat: true },
  },
  data() {
    return {
      controller: '',
      isPausedMenu: this.isPaused,
      isOpenMenu: false,

      menuOpen: false,
      statusOpen: false,
      currentRoute: '',
      links: [
        /* OCB
        {
          name: "home",
          icon: "fa-home",
        },
        FIM OCB */
        {
          name: 'pedidos',
          icon: 'fa-receipt',
        },
        // {
        //   name: 'easy-performance',
        //   icon: 'fa-rocket',
        // },
        /* OCB
        {
          name: 'atendimento',
          icon: 'fa-phone-alt',
        },
        FIM OCB */
        {
          name: 'cupons',
          icon: 'fa-tag',
        },
        {
          name: 'relatorios',
          icon: 'fa-chart-bar',
        },
        {
          name: 'configuracoes',
          icon: 'fal fa-cog',
          getCounter: () => {
            let counter = 0;
            const { storeConfiguration: configurations } = this;

            if (!configurations.catalogChanged) {
              counter += 1;
            }

            if (
              !configurations.images ||
              !configurations.images.logo ||
              !configurations.images.background_mobile
            ) {
              counter += 1;
            }

            return counter;
          },
        },
        {
          name: 'integracoes',
          icon: 'fal fa-puzzle-piece',
        },
      ],
      gridLinks: [
        {
          name: 'minha-conta',
          icon: 'fal fa-address-card',
          title: StringLanguage.myAccount,
        },
      ],
      timeleft: 0,
    };
  },
  components: {
    DrawerStoreDetails,
  },
  props: {
    isOpen: { type: Boolean, default: false },
    isPaused: { type: Boolean, default: false },
    userName: { type: String, default: 'Usuário' },
  },
  async mounted() {
    if (!this.storeConfiguration.isNotFirstTime) {
      await StoreAPI.storeConfiguration({ isNotFirstTime: true });
      this.$refs.drawerStoreDetails.openDrawer();
    }
  },
  methods: {
    timerController() {
      if (!this.storeConfiguration.working_time) {
        this.$store.dispatch('store/getConfigurations', false);
      }

      const storeObject = Store.fromObject(this.storeConfiguration);
      const now = Timezone.adjustTime(new Date(), 0);
      const open = storeObject.working_time.isOpen(now);
      if (open) {
        this.isOpenMenu = true;
        this.isPausedMenu = false;
      } else {
        this.isOpenMenu = false;
        this.isPausedMenu = false;
      }
    },
    openDrawer() {
      this.$refs.drawerStoreDetails.openDrawer();
    },
    isRoute(link) {
      if (this.currentRoute == link.name && !this.menuOpen) {
        return true;
      }
      return false;
    },
    changeTo(routeName) {
      router.push(routeName);
      this.menuOpen = false;
    },
    pauseStore(unit, interval) {
      this.$emit('pauseStore', { unit, interval });
      this.statusOptions = !this.statusOptions;
    },
    onSwipeUp(direction) {
      if (direction == 'top') this.menuOpen = true;
    },
    onSwipeDown(direction) {
      if (direction == 'bottom') this.menuOpen = false;
    },
    logout() {
      setXUserKey();
      this.$store.dispatch('account/cleanUser');
      this.$store.dispatch('deliveryPlatform/cleanConfigurations');
      SocketIO.close();
      this.$router.push({ name: 'login' });
    },
    updateMenu() {
      this.currentRoute = this.$router.currentRoute.name;
      this.menuOpen = false;
    },
    calculeTimePaused() {
      if (this.storeConfiguration.status) {
        const dest = dayjs(this.storeConfiguration.status.paused).add(
          this.storeConfiguration.status.unit,
          this.storeConfiguration.status.interval
        );
        if (dayjs().isAfter(dest)) {
          if (this.isPausedMenu) {
            this.$store.dispatch('store/getConfigurations', false);
          }
        }
        this.timeleft = Utils.timeTo(dest);
      }
    },
    timeLeft() {
      this.calculeTimePaused();
    },
    publishStore() {
      this.$store.dispatch('store/changePublishStatus', true);
    },
    toggleUpdate() {
      store.commit('store/setHasUpdate', true);
      store.commit('store/setUpdateLater', false);
    },
  },
  created() {
    this.currentRoute = this.$router.currentRoute.name;
    this.timerController();
    setInterval(this.timerController, 30000);
    // this.calculeTimePaused()
  },
  watch: {
    // Ações na troca de rota
    $route(to, from) {
      this.currentRoute = this.$router.currentRoute.name;
    },
    storeConfiguration() {
      this.calculeTimePaused();
      this.timerController();
    },
  },
  computed: {
    ...mapState({
      storeConfiguration: (state) => state.store.configurations,
      hasUpdate: (state) => state.store.hasUpdate,
      updateLater: (state) => state.store.updateLater,
    }),
  },
};
</script>

<style scoped>
.footer-mobile * {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

.footer-mobile {
  background: var(--background-up);
  box-shadow: 0px 0px 6px #0000001a;
  position: fixed;
  width: 100vw;
  bottom: 0;
  left: 0;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  z-index: 1000;
  transition: all 0.5s ease-in-out;
}

.footer-mobile.menu-open {
  background: var(--background);
  animation: toTop 0.8s ease-in-out forwards;
  height: 100%;
}

@keyframes toTop {
  100% {
    top: 0;
    margin-top: auto;
  }
}

@-webkit-keyframes toTop {
  100% {
    top: 0;
    margin-top: auto;
  }
}

.footer-mobile ul.shortcuts {
  list-style: none;
  width: 100%;
  padding: 0;
  margin: 0;
  font-size: 18px;
  background-color: var(--background);
  height: 60px;
}

.footer-mobile ul.shortcuts > div {
  display: flex;
  align-items: center;
}

.footer-mobile.menu-open ul.shortcuts {
  background-color: var(--background-up);
}

.footer-mobile .shortcuts li {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.footer-mobile .shortcuts li a {
  color: var(--icon-inactive);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  position: relative;
}

.footer-mobile:not(.menu-open) .shortcuts.ios li a {
  padding-bottom: 10px;
}

.footer-mobile.menu-open .shortcuts li a {
  color: #666666a3;
}

.footer-mobile .shortcuts li.open-menu {
  font-size: 16px;
}

.footer-mobile .shortcuts li.open-menu.open {
  color: var(--success);
}

.footer-mobile .shortcuts li.open-menu.close {
  color: var(--icon-inactive);
}

.footer-mobile .shortcuts li.open-menu .plus {
  border-left: 1px solid #9999992e;
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.footer-mobile:not(.menu-open) .shortcuts.ios li.open-menu .plus {
  margin-bottom: 10px;
  height: 30px;
}

.footer-mobile .shortcuts li.open-menu.real-active.open {
  border-left-color: #9999992e;
}

.footer-mobile
  .shortcuts
  li.real-active
  a.router-link-exact-active.router-link-active {
  color: var(--default);
  border-color: var(--default);
}

.footer-mobile .shortcuts li.real-active:last-child {
  color: #c9c9c9;
}

.footer-mobile .shortcuts li.real-active:last-child i.rotate {
  transform: rotate(225deg);
}

.store-details {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background: #2a2c2f;
  width: 40px;
  color: #8c8c8c;
  margin-left: 15px;
  font-size: 16px;
}

.menu-mobile {
  background-color: var(--background);
  width: 100%;
  height: 100%;
  padding: 0 15px;
}

.menu-mobile .greetings {
  text-align: center;
  font-size: 16px;
  color: #c9c9c9;
  padding: 25px 0;
}

.menu-mobile .greetings .name {
  font-weight: bold;
}

.menu-mobile ul.menu-grid {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 25px;
}

.menu-mobile ul.menu-grid li {
  width: 100%;
  margin-bottom: 10px;
}

.menu-mobile ul.menu-grid li a {
  display: flex;
  align-items: center;
  color: #999999;
  padding: 20px 25px;
  height: 100%;
  text-decoration: none;
  width: 100%;
  border-radius: 5px;
  justify-content: flex-start;
  position: relative;
  background-color: #414147;
}

.menu-mobile ul.menu-grid li a.router-link-exact-active.router-link-active {
  border-left: 3px solid var(--default);
  color: var(--default);
}

.menu-mobile ul.menu-grid li a p {
  font-size: 12px;
}

.menu-mobile ul.menu-grid li a i.fa-chevron-right {
  font-size: 11px;
  position: absolute;
  right: 25px;
}

.menu-mobile ul.menu-grid li a .icon {
  margin-right: 10px;
  width: 23px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-mobile ul.menu-grid li a i {
  font-size: 18px;
}

.status-store {
  padding: 10px;
  border-radius: 5px;
}

.status-store .status {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-right: 15px;
}

.status-store .status > .circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  filter: blur(2px);
}

.status-store .status.open > .circle {
  background-color: #0dc59d5c;
}

.status-store .status.close > .circle {
  background-color: #9f3041ba;
}

.status-store .status > .circle + i {
  position: absolute;
  font-size: 9px;
}

.status-store .status .open {
  background-color: #0dc59d1a;
}
.status-store .status .open > .circle {
  background-color: #0dc59d78;
}
.status-store .status .open > .circle + i {
  color: var(--success);
}
.status-store .status .close,
.status-store .status .pause,
.status-store .status .loading {
  background-color: transparent;
}
.status-store .status .close > .circle {
  background-color: #e2556963;
}
.status-store .status .close > .circle + i {
  color: #e25569;
}
.status-store .status .pause > .circle {
  background-color: #ddd;
}
.status-store .status .pause > .circle + i {
  color: #333;
}

.status-target {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Rubik', sans-serif;
}

.status-option {
  width: 100%;
  padding: 15px 25px;
  background: var(--default);
  margin-top: 10px;
  margin-bottom: 5px;
  border-radius: 5px;
  font-size: 1.2em;
  font-weight: 400;
}

.no-decoration {
  text-decoration: none;
}

.publish-text {
  font-size: 1.4em;
  font-weight: 600;
  color: var(--success);
  text-align: center;
}

.status-store.open {
  background: #0dc59d33;
}

.status-store.open .status-target {
  color: var(--success);
}

.status-store.close {
  background: #e2556933;
}

.status-store.close .status-target {
  color: #d94158;
}

.get-update {
  box-shadow: var(--default);
  animation: pulse 2s infinite;
  text-align: center;
  color: var(--default);
  padding: 20px 0;
  background: var(--background-up);
  font-size: 14px;
  margin-bottom: 15px;
}

.notification {
  width: 19px;
  height: 19px;
  background: var(--default);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #fff;
  position: absolute;
  right: 15px;
  top: 10px;
}

a.router-link-exact-active.router-link-active[href*='configuracoes']
  .notification {
  display: none;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 var(--default);
  }

  70% {
    box-shadow: 0 0 0 10px rgba(0, 136, 221, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(0, 136, 221, 0);
  }
}

@media (max-width: 991px) and (orientation: landscape) {
  .footer-mobile {
    display: none;
  }
}
</style>
